import { render, staticRenderFns } from "./GlobalIngredients.vue?vue&type=template&id=cab39e58"
import script from "./GlobalIngredients.vue?vue&type=script&lang=ts"
export * from "./GlobalIngredients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports